import { ReactNode } from 'react';
import { DropdownMenuItem } from '@/components/atoms/ui/dropdown-menu';
import { cn } from '@/lib/utils';

export interface MenuItemProps {
  variant?: 'default' | 'board';
  icon?: ReactNode;
  children: ReactNode;
  onClick?: () => void;
  onSelect?: (e: Event) => void;
  className?: string;
}

export const MenuItem: React.FC<MenuItemProps> = ({
  variant = 'default',
  icon,
  children,
  onClick,
  onSelect,
  className,
}) => {
  const isBoardVariant = variant === 'board';

  return (
    <DropdownMenuItem
      onClick={onClick}
      onSelect={onSelect}
      className={cn(
        'menu-item-component',
        isBoardVariant
          ? 'text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-white/10 focus:bg-gray-100 dark:focus:bg-white/10 hover:text-gray-900 dark:hover:text-white focus:text-gray-900 dark:focus:text-white'
          : 'text-popover-foreground hover:bg-accent focus:bg-accent',
        className
      )}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </DropdownMenuItem>
  );
};

